export default __webpack_public_path__ + "static/Optima Medium-41b0183f1591826d5bae706fac58900a.woff";